// src/api/reviews.ts — public product-review reads for the storefront.
// Submission stays in customer.ts (submitOrderReview — JWT-authenticated);
// admin moderation lives in admin.ts. This module is the public read side:
// only reviews an admin has published are ever returned.

import { ApiResult } from "../types/ApiResult";

const apiKey = process.env.REACT_APP_FUNCTION_SECRET;
const authHeaders: HeadersInit = apiKey ? { "x-api-key": apiKey } : {};

export interface ProductReview {
  rating: number;
  text: string;
  /** Display name only (e.g. "Paul M." or "Verified Buyer") — never an email. */
  author: string;
  createdAt: string;
}

export interface ProductReviewsSummary {
  itemId: string;
  count: number;
  /** Average of published ratings rounded to 1 decimal; null when no reviews. */
  averageRating: number | null;
  reviews: ProductReview[];
}

/** Fetch the published reviews for a catalog item (product page). */
export const getProductReviews = async (
  itemId: string,
): Promise<ApiResult<ProductReviewsSummary>> => {
  try {
    const res = await fetch(
      `/.netlify/functions/get-product-reviews?itemId=${encodeURIComponent(itemId)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json", ...authHeaders },
      },
    );
    return res.json();
  } catch (error) {
    return { error: `Failed to load reviews: ${error}` };
  }
};
